'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// ./~/.0.2.1@querystring-es3/index.js
// module id = 36
// module chunks = 0